import {
  POST_FIELDS,
  OPERATION,
  ENTITIES,
  SAC_STATUS_FIELDS,
} from '@/services/charts-service';
import { DATA_TYPE, SUBDATA_TYPE, FILTER_NAMES } from '@/store/modules/cards/constants';

/*
  Property of change logs objects:

  control: in Timestamp (to generate the time use (new Date()).getTime())
  match: Array,
    property: Any,
  change: Object,
    property: Any,
*/

export default [
  {
    control: 1630085066000,
    match: [
      {
        component: 'TopInfluencers',
      },
      {
        component: 'TopPosts',
      },
      {
        component: 'TopLikedPosts',
      },
      {
        component: 'NewPosts',
      },
      {
        component: 'TopPostsByFollowers',
      },
      {
        component: 'TopPostsByInteractions',
      },
      {
        component: 'PropBaseShareSentiment',
        props: {
          operation: OPERATION.COUNT,
          group: POST_FIELDS.OPERATOR,
        },
      },
    ],
    change: {
      shareable: false,
    },
  },
  {
    control: 1660824687000,
    match: [
      {
        component: 'EngagementMatrix',
      },
    ],
    change: {
      props: {
        description: 'Compara engajamento, impressões e índice de sentimento dos comentários das publicações proprietárias do período. A divisão dos quadrantes é data pela média aritimética dos últimos 90 dias.',
      },
    },
  },
  {
    control: 1660824688000,
    match: [
      {
        component: 'EngagementMatrix',
        props: {
          type: 'tags',
        },
      },
    ],
    change: {
      props: {
        description: 'Compara engajamento, impressões e índice de sentimento dos comentários das publicações do período, por tag. A divisão dos quadrantes é data pela média aritimética dos últimos 90 dias.',
      },
    },
  },
  {
    control: 1661879019000,
    match: [
      {
        component: 'SacReportCallsQuantity',
      },
      {
        component: 'PropBaseShareSentiment',
        shareable: false,
      },
    ],
    change: {
      dataType: DATA_TYPE.SAC_STATUS,
    },
  },
  {
    control: 1662392706000,
    match: [
      {
        component: 'SessionDivider',
      },
    ],
    change: {
      hideMenu: true,
    },
  },
  {
    control: 1666374586000,
    match: [
      {
        component: 'PropBaseShareSentiment',
        props: {
          tags: 'Sentimento; Canais',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1666655334000,
    match: [
      {
        component: 'AnnotationTextCard',
      },
    ],
    change: {
      props: {
        noPadding: true,
      },
    },
  },
  {
    control: 1669299432000,
    match: [
      {
        component: 'AnnotationImageCard',
      },
    ],
    change: {
      props: {
        description: 'Componente para inserir imagens por arquivo ou via URLs.',
      },
    },
  },
  {
    control: 1673267129000,
    match: [
      {
        component: 'PropBaseShareSentiment',
        props: {
          tags: 'Sentimento; Categorias e Anotações',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1673268119000,
    match: [
      {
        component: 'PropSentimentTimeSeries',
        props: {
          tags: 'Sentimento; Engajamento',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1673272320000,
    match: [
      {
        component: 'PropSentimentGauge',
        props: {
          tags: 'Sentimento; Engajamento',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1673272604000,
    match: [
      {
        component: 'PropBaseShareSentiment',
        props: {
          tags: 'Sentimento; Demográficos',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1673272743000,
    match: [
      {
        component: 'PropBaseShareSentiment',
        props: {
          tags: 'Sentimento; Categorias e Anotações',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1673273013000,
    match: [
      {
        component: 'PropSentimentPie',
        props: {
          tags: 'Sentimento; Engajamento',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1673273264000,
    match: [
      {
        component: 'PropSentimentTimeSeries',
        props: {
          tags: 'Sentimento ; Engajamento',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1673273530000,
    match: [
      {
        component: 'PropBaseShareSentiment',
        props: {
          tags: 'Menções e Publicações; Categorias e Anotações',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1673273683000,
    match: [
      {
        component: 'PropBaseShareSentiment',
        props: {
          tags: 'Menções e Publicações; Categorias e Anotações',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1673273962000,
    match: [
      {
        component: 'EngagementMatrix',
        props: {
          tags: 'Engajamento',
          type: 'tags',
        },
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1677505930416,
    match: [
      {
        component: 'BacklogTable',
      },
      {
        component: 'ChangeStatus',
      },
      {
        component: 'SLAGaugeChart',
      },
      {
        component: 'AnnotationsLogs',
      },
      {
        component: 'ReportOperatorsLogs',
      },
      {
        component: 'StockVsSentimentLineChart',
      },
      {
        component: 'StockVsSocialLineChart',
        props: {
          title: 'Comparativo preço x menções',
        },
      },
      {
        component: 'StockVsSocialLineChart',
        props: {
          title: 'Comparativo volume x menções',
        },
      },
      {
        component: 'TextFilter',
      },
      {
        component: 'LogsTable',
      },
    ],
    change: {
      shareable: false,
    },
  },
  {
    control: 1679342640000,
    match: [
      {
        component: 'FanBaseEvolutionChart',
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1679342640001,
    match: [
      {
        component: 'FansTotal',
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1679342640002,
    match: [
      {
        component: 'NewFans',
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: true,
          disableTag: false,
          disableTheme: false,
          disablePolarity: false,
        },
      },
    },
  },
  {
    control: 1695038789000,
    match: [
      {
        props: {

          originalTitle: 'Mensagens Recebidas',
        },
      },
      {
        props: {
          originalTitle: 'Mensagens Enviadas',
        },
      },
      {
        props: {
          originalTitle: 'Mensagens Enviadas por Intervalo',
        },
      },
      {
        props: {
          originalTitle: 'Mensagens Recebidas por Intervalo',
        },
      },
      {
        props: {
          originalTitle: 'Volume de mensagens no período',
        },
      },
      {
        props: {
          originalTitle: 'Total de mensagens trafegadas',
        },
      },
    ],
    change: {
      subDataType: SUBDATA_TYPE.BLIP.MESSAGES,
    },
  },
  {
    control: 1695038814000,
    match: [
      {
        props: {
          originalTitle: 'Mensagens Ativas',
        },
      },
      {
        props: {
          originalTitle: 'Mensagens Ativas por Intervalo',
        },
      },
      {
        props: {
          originalTitle: 'Mensagens ativas por canal',
        },
      },
    ],
    change: {
      subDataType: SUBDATA_TYPE.BLIP.ACTV_MESSAGES,
    },
  },
  {
    control: 1695038826000,
    match: [
      {
        props: {
          originalTitle: 'Total de Contatos Únicos no Período',
        },
      },
      {
        props: {
          originalTitle: 'Contatos com Interação no Período',
        },
      },
      {
        props: {
          originalTitle: 'Contatos Únicos por Intervalo',
        },
      },
      {
        props: {
          originalTitle: 'Contatos com Interação por Intervalo',
        },
      },
      {
        props: {
          originalTitle: 'Contatos que não responderam',
        },
      },
      {
        props: {
          originalTitle: 'Contatos com interação x Contatos que não responderam',
        },
      },
      {
        props: {
          originalTitle: 'Taxa de rejeição',
        },
      },
      {
        props: {
          originalTitle: 'Taxa de interação',
        },
      },
    ],
    change: {
      subDataType: SUBDATA_TYPE.BLIP.CONTACTS,
    },
  },
  {
    control: 1695038837000,
    match: [
      {
        props: {
          originalTitle: 'Total de Eventos Personalizados',
        },
      },
      {
        props: {
          originalTitle: 'Distribuição de Eventos Personalizados',
        },
      },
      {
        props: {
          originalTitle: 'Distribuição de Eventos Personalizados (Percentual)',
        },
      },
      {
        props: {
          originalTitle: 'Eventos Personalizados no Tempo',
        },
      },
    ],
    change: {
      subDataType: SUBDATA_TYPE.BLIP.EVENTS,
    },
  },
  {
    control: 1698158166678,
    match: [
      {
        component: 'OperatorsStatus',
      },
    ],
    change: {
      props: {
        selectedFilters: [FILTER_NAMES.SAC_REPLIER, FILTER_NAMES.SAC_REPLIER_STATUS],
      },
    },
  },
  {
    control: 1698182368141,
    match: [
      {
        component: 'TextFilter',
      },
    ],
    change: {
      props: {
        selectedFilters: [FILTER_NAMES.TEXT_QUERY, FILTER_NAMES.TAG],
      },
    },
  },
  {
    control: 1702389127059,
    match: [
      {
        component: 'GPTSuggestions',
      },
    ],
    change: {
      props: {
        title: 'Sugestão de Respostas via ChatGPT',
        originalTitle: 'Sugestão de Respostas via ChatGPT',
        selectedFilters: [FILTER_NAMES.THEME, FILTER_NAMES.GROUP, FILTER_NAMES.CHANNEL],
      },
    },
  },
  {
    control: 1707149561000,
    match: [
      {
        component: 'BlipConversionFunnel',
      },
    ],
    change: {
      desk: {
        notSupportDeskFilters: true,
      },
    },
  },
  {
    control: 1707152237000,
    match: [
      {
        component: 'BlipCampaignsTable',
      },
    ],
    change: {
      desk: {
        notSupportDeskFilters: true,
      },
    },
  },
  {
    control: 1707750000000,
    match: [
      {
        component: 'BlipMonitoringTicketsCount',
      },
    ],
    change: {
      desk: {
        notSupportDeskFilters: false,
      },
    },
  },
  {
    control: 1707750060000,
    match: [
      {
        component: 'BlipMonitoringTicketMetrics',
      },
    ],
    change: {
      desk: {
        notSupportDeskFilters: false,
      },
    },
  },
  {
    control: 1707750120000,
    match: [
      {
        component: 'BlipOpenTicketsTable',
      },
    ],
    change: {
      desk: {
        notSupportDeskFilters: false,
      },
    },
  },
  {
    control: 1707750180000,
    match: [
      {
        component: 'BlipMonitoringAttendantsTable',
      },
    ],
    change: {
      desk: {
        notSupportDeskFilters: false,
      },
    },
  },
  {
    control: 1707750240000,
    match: [
      {
        component: 'BlipWaitingTicketsTable',
      },
    ],
    change: {
      desk: {
        notSupportDeskFilters: false,
      },
    },
  },
  {
    control: 1707750300000,
    match: [
      {
        component: 'BlipMonitoringTeamsTable',
      },
    ],
    change: {
      desk: {
        notSupportDeskFilters: false,
      },
    },
  },
  {
    control: 1707750360000,
    match: [
      {
        component: 'BlipTagsMetricsTable',
      },
    ],
    change: {
      desk: {
        notSupportDeskFilters: false,
      },
    },
  },
  {
    control: 1708363547366,
    match: [
      {
        component: 'InterestLovers',
      },
    ],
    change: {
      props: {
        selectedFilters: [FILTER_NAMES.LOVERS_HATERS, FILTER_NAMES.UIDS, FILTER_NAMES.PAGES],
      },
    },
  },
  {
    control: 1708372969224,
    match: [
      {
        component: 'GPTSuggestions',
      },
    ],
    change: {
      props: {
        selectedFilters: [FILTER_NAMES.THEME, FILTER_NAMES.GROUP, FILTER_NAMES.CHANNEL, FILTER_NAMES.REPLIED],
      },
    },
  },
  {
    control: 1710956369283,
    match: [
      {
        component: 'BlipCampaignsTable',
      },
      {
        component: 'BlipConversionFunnel',
      },
    ],
    change: {
      audience: {
        suportScheduledFilters: true,
      },
    },
  },
  {
    control: 1718043521088,
    match: [
      {
        component: 'OwnedEarnedPostReach',
      },
    ],
    change: {
      props: {
        title: 'Total de publicações Owned e Earned',
        originalTitle: 'Total de publicações Owned e Earned',
      },
    },
  },
  {
    control: 1721822289868,
    match: [
      {
        component: 'TagShareSACPieChart',
      },
    ],
    change: {
      props: {
        title: 'Publicações por tag',
        originalTitle: 'Publicações por tag',
      },
    },
  },
  {
    control: 1729710544977,
    match: [
      {
        component: 'PropBaseShareSentiment',
        props: {
          originalTitle: 'Atendimentos por Operadores',
        },
      },
    ],
    change: {
      props: {
        group: SAC_STATUS_FIELDS.userName,
        entity: ENTITIES.SAC_STATUS,
      },
    },
  },
  {
    control: 1742390559002,
    match: [
      {
        component: 'BaseShareSentiment',
        props: {
          originalTitle: 'Sentimento por Canal',
        },
      },
    ],
    change: {
      props: {
        polarity: true,
      },
    },
  },
  {
    control: 1742390559003,
    match: [
      {
        component: 'BaseShareSentiment',
        props: {
          originalTitle: 'Sentimento por Tag',
        },
      },
    ],
    change: {
      props: {
        polarity: true,
      },
    },
  },
  {
    control: 1742395872000,
    match: [
      {
        component: 'BaseShareSentiment',
        props: {
          originalTitle: 'Sentimento por Gênero',
        },
      },
    ],
    change: {
      props: {
        polarity: true,
      },
    },
  },
  {
    control: 1743536577380,
    match: [
      {
        component: 'SumPostsAndInteractionsInTime',
      },
    ],
    change: {
      props: {
        title: 'Publicações no tempo',
        originalTitle: 'Publicações no tempo',
      },
    },
  },
  {
    control: 1792180224744,
    match: [
      {
        component: 'PropSentimentPie',
      },
    ],
    change: {
      control: {
        tiktok: {
          hideInChannel: false,
        },
      },
      props: {
        filterId: null,
      },
    },
  },
];
